<template>
  <div class="wealth">
    <img
      src="../../assets/img/wealth/bg_wealth_top.png"
      alt=""
      class="bg_img"
    />
    <div class="top-box">
      <div class="header">
        <span class="caifu">{{ $t("财富") }}</span>
        <router-link to="/against" class="flex-center">
          <div class="shandui">
            <img src="../../assets/img/wealth/fangkuang.png" alt="" />
            <span>{{ $t("闪兑") }}</span>
          </div>
          ····
        </router-link>
      </div>
      <div class="title">{{ $t("财富资产") }}</div>
      <div class="desc-info">
        <span>{{ currency_char }}</span>
        <span class="totalMoney">{{
          (total * currency_usd_rate) | numFilter | toThousandFilter
        }}</span>
      </div>
      <div class="right-arrow" @click="mywealth()">
        <img src="../../assets/img/wealth/arrow_right.png" alt="" />
      </div>
    </div>
    <!--    挖矿、币计划-->
    <div class="menu-box">
      <div class="item" @click="huoqi()">
        <div class="img-left">
          <img src="../../assets/img/wealth/wa_kuang.png" alt="" />
        </div>
        <span>HMCPlusCoin</span>
      </div>
      <div class="item" @click="siqi()">
        <div class="img-right">
          <img src="../../assets/img/wealth/b_plan.png" alt="" />
        </div>
        <span>{{ $t("币计划") }}</span>
      </div>
    </div>
    <!--    热门推荐-->
    <p class="hot-recommend">{{ $t("热门推荐") }}</p>
    <div class="recommend-list">
      <div
        v-for="val in hot"
        @click="plandetail(val.name, val.id)"
        class="item_hot"
      >
        <img v-bind:src="val.coin_icon" class="oImg" alt="" />
        <div class="right-box">
          <div class="line-top">
            <span class="name">{{ val.name }}</span>
            <span class="rank">{{ val.annualized_returns }}</span>
          </div>
          <div class="line-bottom">
            <div class="left-attr">
              <span class="left_lable" v-for="val in val.flag">{{ val }}</span>
            </div>
            <span class="right_lable">{{ $t("预期年化收益") }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from "mint-ui";
import { httpGetBanner, httpGetHot, httpGetMywealth } from "@/api/wealth";

export default {
  data: function () {
    return {
      hot: [],
      currency: "",
      currency_char: "",
      currency_usd_rate: "",

      total: 0,
    };
  },
  activated() {
    (this.currency = this.$store.state.currency),
      (this.currency_char = this.$store.state.currency_char),
      (this.currency_usd_rate = this.$store.state.currency_usd_rate),
      this.getMywealth();
  },
  filters: {
    numFilter(value) {
      let transformVal = Number(value).toFixed(6);
      let realVal = transformVal.substring(0, transformVal.length);
      return Number(realVal).toFixed(6);
    },
  },
  mounted() {
    this.getHot();
  },
  methods: {
    getHot: function () {
      // 理财热门推荐
      httpGetHot({ limit_begin: 0, limit_num: 10 })
        .then((res) => {
          this.hot = res.data.list;
          /* for(var i=0;i<this.hot.length;i++){
              this.hot[i].coin_icon = window.getLocalCoinImg(this.hot[i].coin_symbol);
            } */
        })
        .catch(() => {});
    },

    getMywealth: function () {
      httpGetMywealth()
        .then((res) => {
          this.total = res.data.total;
        })
        .catch(() => {});
    },
    huoqi() {
      this.$router.push("/pos");
    },
    siqi() {
      this.$router.push("/coinplan");
    },

    // 每个热门列表的详情
    plandetail(title, id) {
      this.$router.push({
        path: "/plandetail",
        query: { title: title, id: id },
      });
    },
    mywealth() {
      this.$router.push("/mywealth");
    },
  },
};
</script>

<style scoped lang="less">
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.bg_img {
  width: 100%;
  height: 210px;
  position: absolute;
}

.top-box {
  position: relative;
  //padding-top: 70px;

  .header {
    width: 100%;
    height: 50px;
    //background-color: #00b191;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .caifu {
      font-size: 21px;
      color: #ffffff;
      margin-left: 21px;
      opacity: 0.8;
    }

    .shandui {
      height: 32px;
      background: rgba(255, 255, 255, 0.16);
      border-radius: 16px;
      padding: 0 16px;
      display: flex;
      align-items: center;

      span {
        color: #ffffff;
        line-height: 32px;
        font-size: 14px;
        opacity: 0.8;
      }

      img {
        width: 17px;
        height: 14px;
        margin-right: 11px;
      }
    }
  }

  .title {
    font-size: 13px;
    font-weight: 500;
    color: #f5ca6e;
    margin-top: 20px;
    opacity: 0.4;
    text-align: center;
  }

  .desc-info {
    color: #f5ca6e;
    display: flex;
    justify-content: center;
    padding-top: 12px;

    .totalMoney {
      font-size: 33px;
      font-weight: bold;
      color: #f5ca6e;
      margin-left: 10px;
    }
  }

  .right-arrow {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 20px;
    top: 80px;

    img {
      width: 8px;
      height: 15px;
      display: block;
      margin: 0 auto;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}

.menu-box {
  position: relative;
  width: calc(100% - 30px);
  height: 70px;
  background: #ffffff;
  box-shadow: 0px 1px 9px 0px rgba(161, 161, 161, 0.19);
  border-radius: 5px;
  margin: 38px 15px 0;

  display: flex;
  //justify-content: space-around;
  //align-items: center;

  font-size: 13px;
  font-weight: 500;
  color: #96793a;

  .item {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .img-left {
    margin-right: 14px;

    img {
      width: 34px;
      height: 36px;
    }
  }

  .img-right {
    margin-right: 14px;

    img {
      width: 35px;
      height: 39px;
    }
  }
}

.hot-recommend {
  font-size: 15px;
  font-weight: bold;
  color: #333333;
  margin-top: 20px;
  padding-left: 20px;
}

.recommend-list {
  margin: 15px;
  background: #ffffff;
  border-radius: 5px;

  .item_hot {
    height: 86px;
    box-sizing: border-box;
    display: flex;
    justify-content: start;
    padding: 0 15px;

    .oImg {
      width: 34px;
      height: 34px;
      margin-top: 20px;
      margin-right: 18px;
    }

    .right-box {
      margin-top: 20px;
      width: 100%;

      .line-top {
        display: flex;
        justify-content: space-between;

        .name {
          font-size: 14px;
          font-weight: bold;
          color: #333333;
        }

        .rank {
          font-size: 21px;
          font-weight: bold;
          color: #1c74f2;
        }
      }

      .line-bottom {
        display: flex;
        justify-content: space-between;
        margin-top: 14px;

        .left-attr {
          font-size: 10px;
          font-weight: 500;
          color: #ccad60;

          .left_lable {
            background: #fbf6f1;
            border-radius: 3px;
            padding: 2px 8px;
          }
        }

        .right_lable {
          font-size: 12px;
          float: right;
          border-radius: 4px;
          color: #8c92a8;
        }
      }
    }
  }
}
</style>
